import {
  FragmentType,
  useFragment as getFragment,
} from '$contentful-gql/index';

import { pathSegmentFragment } from '../common/fragments';

export function getUrlProps(url: FragmentType<typeof pathSegmentFragment>) {
  return getFragment(pathSegmentFragment, url);
}
